import React from 'react';
import { PageIntro } from '../components/PageIntro';
import { ScenarioList } from '../components/ScenarioList';
import { ContactBand } from '../components/ContactBand';
import { capabilities, domains } from '../data/capabilities';
export function Services() {
  return <>
      <PageIntro eyebrow="Services" title="We work in unison with your teams to educate, recommend, execute, and deliver." lead="Research Science Group provides advanced software development services enabling developers, teams, and organizations to understand and take advantage of changing technology. These services are intended for innovators who want to push the known limits of software technology and make full use of cutting-edge advances in order to succeed in the marketplace — so that your teams succeed where others fail." data-id="element-253" data-mp="3jjup9yy5w70n" />

      <section className="mx-auto max-w-6xl px-6 py-20 lg:px-10" aria-labelledby="capabilities" data-id="element-254" data-mp="2cvo0xozgkwhn">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.6fr] lg:gap-20" data-id="element-255" data-mp="27y5ovpq5a15f">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-256" data-mp="16q48km9ccqlu">
            <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-257" data-mp="1bnnxcg3o0ls1">What we do</p>
            <h2 id="capabilities" className="mt-4 font-display text-[30px] leading-tight text-ink-950" data-id="element-258" data-mp="1fpizfmtf736v">
              Six kinds of work
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-500" data-id="element-259" data-mp="1khsjim7ut918">
              Most engagements combine several of these. We are equally comfortable advising and
              writing the code ourselves.
            </p>
          </div>

          <ol className="border-t border-ink-200" data-id="element-260" data-mp="1zdi88s4fc09n">
            {capabilities.map((capability, index) => <li key={capability.title} className="grid gap-2 border-b border-ink-200 py-7 sm:grid-cols-[3rem_1fr] sm:gap-6" data-id="element-261" data-mp="23etqgckyxj7t" data-mpi={index}>
                <span className="font-display text-sm text-accent" aria-hidden="true" data-id="element-262" data-mp="51tqki6t5jlk">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div data-id="element-263" data-mp="1ccrkyfao0kup">
                  <h3 className="font-display text-[20px] leading-snug text-ink-950" data-id="element-264" data-mp="1ce2l854wjah2">
                    {capability.title}
                  </h3>
                  <p className="mt-2 max-w-prose text-[15px] leading-relaxed text-ink-700" data-id="element-265" data-mp="1lcwoufgnh144">
                    {capability.description}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-y border-ink-200 bg-paper-sunk" aria-labelledby="domains" data-id="element-266" data-mp="1v8rfnxv122hz">
        <div className="mx-auto max-w-6xl px-6 py-16 lg:px-10" data-id="element-267" data-mp="1q9n5b3wd9yq2">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.6fr] lg:gap-20" data-id="element-268" data-mp="24zm2p4g3l64h">
            <div data-id="element-269" data-mp="20110x0l76edx">
              <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-270" data-mp="202luamvrzra7">Where we work</p>
              <h2 id="domains" className="mt-4 font-display text-[26px] leading-tight text-ink-950" data-id="element-271" data-mp="2e2dcz0x8lvuj">
                Customer domains
              </h2>
            </div>
            <ul className="flex flex-wrap gap-x-3 gap-y-3" data-id="element-272" data-mp="2soaghqtzc9a4">
              {domains.map(domain => <li key={domain} className="border border-ink-200 bg-paper px-3.5 py-2 text-sm text-ink-700" data-id="element-273" data-mp="2xnndh4ekewqf">
                  {domain}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 py-20 lg:px-10" aria-labelledby="scenarios" data-id="element-274" data-mp="29xj74p9zsivq">
        <div className="max-w-2xl" data-id="element-275" data-mp="2eo9gedljh5vp">
          <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-276" data-mp="2epb2dd43fcs7">Scenarios</p>
          <h2 id="scenarios" className="mt-4 font-display text-[32px] leading-tight text-ink-950 sm:text-[38px]" data-id="element-277" data-mp="2004texfge874">
            Four situations we are usually called into
          </h2>
          <p className="mt-4 text-[16px] leading-relaxed text-ink-700" data-id="element-278" data-mp="1qyxapnpf7fy5">
            If one of these reads like a description of your project, the conversation will be a
            short one.
          </p>
        </div>
        <div className="mt-12" data-id="element-279" data-mp="1nxbyk1gaifr0">
          <ScenarioList data-id="element-280" data-mp="1nwalxsjmll76" />
        </div>
      </section>

      <ContactBand heading="If you have hard problems that need solving, let's explore how we may work together." body="Send us the shape of the problem — what you have tried, where it stalls, and what success would look like." data-id="element-281" data-mp="1ixh982c5xy82" />
    </>;
}